import axios from "axios";
import {
  decrypt,
  getAccountSessionStudies,
  getClaims,
  getUserProfile,
  isStudyEnrolled,
} from "../../../modules/login";
import { profiles } from "../../../modules/constants";
import { globalAction } from "redux-subspace";
import history from "../../../modules/history";
import { getUnauthorizedStudyStatus } from "../../../modules/utils";

const SET_USER_INFO = "SET_USER_INFO";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";
const SET_STUDY_STATUS = "SET_STUDY_STATUS";

// Acessors
const getAccountUsername = (state) => decrypt(state?.loginReducer.name);
const getName = (state) => state.username;
const getRole = (state) => state.role;
const getStudyTitle = (state) => state.studyTitle;
const canViewPersonalData = (state) =>
  getClaims(state, "participant.personalData.canView");
const getStudyStatus = (state) => state.studyStatus;
const getSites = (state) => state?.loginReducer.sites;
const getParticipantUgnxId = (state) => state?.participantUgnxId;
const getParticipantLanguage = (state) => state?.participantLanguage;
const getAccountStatus = (state) => state?.accountStatus;
const getAccountCreatedAt = (state) => state.accountCreatedAt;
const getParticipantDateOfEnrollment = (state) =>
  state?.participantDateOfEnrollment;

// Default state
const initialState = {
  username: "",
  participantUgnxId: "",
  role: "",
  studyTitle: "",
  studyStatus: null,
  participantLanguage: null,
  accountStatus: null,
  accountCreatedAt: null,
  participantDateOfEnrollment: null,
};

export const smartPageHeaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        participantUgnxId: action.participantUgnxId,
        username: action.username,
        role: action.role,
        studyTitle: action.studyTitle,
        studyStatus: action.studyStatus,
        participantLanguage: action.participantLanguage,
        accountStatus: action.accountStatus,
        accountCreatedAt: action.accountCreatedAt,
        participantDateOfEnrollment: action.participantDateOfEnrollment,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const getUserInfo = () => (dispatch, getState) => {
  dispatch({
    type: SET_USER_INFO,
    username: getAccountUsername(getState()),
    role: getUserProfile(getState()),
    studyTitle: null,
    studyStatus: null,
    participantLanguage: null,
    accountStatus: null,
    participantDateOfEnrollment: null,
  });
};

const fetchParticipant = (id) => (dispatch, getState) => {
  const studies = getAccountSessionStudies(getState());

  const params = {
    participantId: id,
    studyId: studies ? studies[0]?.studyId : null,
  };

  return axios
    .get(`/api/participant/contactinformation`, {
      params,
    })
    .then(({ data }) => {
      const userRole = getUserProfile(getState());
      dispatch({
        type: SET_USER_INFO,
        participantUgnxId: data.ugnxId,
        username:
          userRole === profiles.participant
            ? data.ugnxId
            : getAccountUsername(getState()),
        role: getUserProfile(getState()),
        studyStatus: data.studyStatus,
        participantLanguage: data.language,
        accountStatus: data.status,
        accountCreatedAt: data.createdAt,
        participantDateOfEnrollment: data.dateOfEnrollment,
      });

      if (userRole === profiles.participant) {
        const studyId = studies[0]?.studyId;
        studies.forEach((study) => {
          if (study.studyId === studies[0]?.studyId) {
            study.status = data.studyStatus;
          }
        });

        dispatch(globalAction({ type: SET_STUDY_STATUS, studies }));

        if (
          !isStudyEnrolled(
            studyId,
            studies,
            getUnauthorizedStudyStatus(studyId)
          )
        ) {
          history.push("/accessdenied");
        }
      }
    })
    .catch(() => {
      dispatch({
        type: SET_USER_INFO,
        username: null,
        participantUgnxId: null,
        role: getUserProfile(getState()),
        studyStatus: null,
        participantLanguage: null,
        accountStatus: null,
        accountCreatedAt: null,
        participantDateOfEnrollment: null,
      });
    });
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapStateToProps = (state) => {
  return {
    username: getName(state),
    role: getRole(state),
    studyTitle: getStudyTitle(state),
    canViewPersonalData: canViewPersonalData(state),
    studyStatus: getStudyStatus(state),
    sites: getSites(state),
    participantUgnxId: getParticipantUgnxId(state),
    participantLanguage: getParticipantLanguage(state),
    accountStatus: getAccountStatus(state),
    accountCreatedAt: getAccountCreatedAt(state),
    participantDateOfEnrollment: getParticipantDateOfEnrollment(state),
  };
};

export const mapDispatchToProps = {
  getUserInfo,
  fetchParticipant,
  resetState,
};
